import ChallengesSection from "@/Components/DebtPulse/ChallengesSection";
import CtaSection from "@/Components/DebtPulse/CtaSection";
import FaqSection, { faqs } from "@/Components/DebtPulse/FaqSection";
import ProductSeo from "@/Components/seo/ProductSeo";
import { PRODUCTS } from "@/lib/products";
import FeaturesSection from "@/Components/DebtPulse/FeaturesSection";
import HeroSection from "@/Components/DebtPulse/HeroSection";
import ImpactSection from "@/Components/DebtPulse/ImpactSection";
import PricingSection from "@/Components/DebtPulse/PricingSection";
import ProcessSection from "@/Components/DebtPulse/ProcessSection";
import SolutionSection from "@/Components/DebtPulse/SolutionSection";
import TeamsSection from "@/Components/DebtPulse/TeamsSection";

export default function DebtPulse() {
  return (
    <>
      {/* Title, description, OG tags and schema all come from lib/products.js via ProductSeo */}
      <ProductSeo product={PRODUCTS.debtpulse} faqs={faqs} />
      <HeroSection />
      <ChallengesSection />
      <SolutionSection />
      <ProcessSection />
      <FeaturesSection />
      
      <TeamsSection />
      <ImpactSection />
      <PricingSection />
       <CtaSection />
      <FaqSection />
     
    </>
  );
}
